/* VVB Video library: search and filters for sections/vvb-video-library.liquid.
   The filter buttons and the product menu are built from the cards that are on the page, so a video added in the theme editor appears in them automatically.
   Playback is handled by the shared video dialog in vvb.js (buttons with data-video-src). State is kept in the address bar:
   ?type=ugc&product=<handle>&line=blue&category=serum&kind=creator&concern=tone&q=oil  (so the product pages can link to a pre-filtered list).

   One filter for several sections: a library section with "Use the filters of the video library above" switched on (data-vvl-follow)
   shows no filter row of its own; its cards are filtered by the nearest library above it that has its own filters, and the section hides
   itself when none of its cards match. A section holds at most 50 blocks, so long lists continue in following sections this way.

   Every library section includes this file, so the page can load it more than once. It runs once (window.__vvlLoaded) and every section
   is set up once (data-vvl-ready); before 2026-10-10 each copy set up every section, which showed the filter rows twice. */
(() => {
  if (window.__vvlLoaded) return;
  window.__vvlLoaded = true;

  /* Displayed text. English defaults; the section passes the translated strings in data-i18n (locale keys vvb.video.*). */
  const T0 = {
    filters: 'Filters', type_label: 'Type of video', type_all: 'All videos', type_product: 'Product videos', type_ugc: 'UGC · creators',
    group_line: 'Line', group_category: 'Category', group_kind: 'Kind', group_concern: 'Concern',
    count_one: '{n} video', count_other: '{n} videos', match_one: '{shown} of {total} video match', match_other: '{shown} of {total} videos match'
  };
  const GROUPS = [
    { key: 'line', label: 'Line', order: ['blue', 'purple', 'green', 'solution', 'brand'] },
    { key: 'category', label: 'Category', order: ['serum', 'cleanser', 'toner', 'moisturizer', 'mask', 'eye', 'sun', 'kit', 'brand'] },
    { key: 'kind', label: 'Kind', order: ['brand', 'product', 'creator', 'texture'] },
    { key: 'concern', label: 'Concern', order: ['tone', 'hydration', 'balance', 'firmness', 'texture'] }
  ];

  function init(root, followers) {
    if (!root || root.dataset.vvlReady) return;
    root.dataset.vvlReady = '1';
    followers.forEach(f => { f.dataset.vvlReady = '1'; });
    const sections = [root, ...followers];
    let T = T0; try { T = { ...T0, ...JSON.parse(root.dataset.i18n || '{}') }; } catch (e) { /* keep English defaults */ }
    const items = sections.flatMap(r => [...r.querySelectorAll('.vvl-item')]);
    const tools = root.querySelector('[data-vvl-tools]');
    const groupsEl = root.querySelector('[data-vvl-groups]');
    const qEl = root.querySelector('[data-vvl-q]');
    const productEl = root.querySelector('[data-vvl-product]');
    const countEl = root.querySelector('[data-vvl-count]');
    const clearEl = root.querySelector('[data-vvl-clear]');
    const emptyEl = root.querySelector('[data-vvl-empty]');
    if (!items.length || !tools) return;
    tools.querySelectorAll('.vvl-seg').forEach(n => n.remove());
    groupsEl.textContent = '';

    /* what exists on the page */
    const products = new Map();   // handle -> {title, n}
    items.forEach(li => {
      const handles = (li.dataset.products || '').split(/\s+/).filter(Boolean);
      const names = [...li.querySelectorAll('.vvl-prod a[data-handle]')];
      handles.forEach((h, i) => {
        const p = products.get(h) || { title: (names[i] && names[i].textContent.trim()) || h, n: 0 };
        p.n++; products.set(h, p);
      });
    });
    const state = { type: '', q: '', product: '', line: '', category: '', kind: '', concern: '' };

    /* first split: product videos (brand films, promos, textures) vs UGC (creator videos) */
    items.forEach(li => { li.dataset.type = li.dataset.kind === 'creator' ? 'ugc' : 'product'; });
    const seg = document.createElement('div');
    seg.className = 'vvl-seg'; seg.setAttribute('role', 'group'); seg.setAttribute('aria-label', T.type_label);
    [['', T.type_all], ['product', T.type_product], ['ugc', T.type_ugc]].forEach(([v, t]) => {
      const n = v ? items.filter(li => li.dataset.type === v).length : items.length;
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'vvl-segbtn'; b.dataset.type = v;
      b.innerHTML = t + ' <small>' + n + '</small>';
      b.addEventListener('click', () => { state.type = v; apply(); });
      seg.appendChild(b);
    });
    tools.insertBefore(seg, tools.firstChild);

    /* filter groups with 2 or more different values */
    const live = [];
    GROUPS.forEach(g => {
      const vals = new Map();
      items.forEach(li => {
        const v = li.dataset[g.key];
        if (!v) return;
        const e = vals.get(v) || { label: li.dataset[g.key + 'Label'] || v, n: 0 };
        e.n++; vals.set(v, e);
      });
      if (vals.size < 2) return;
      const keys = [...vals.keys()].sort((a, b) => {
        const ia = g.order.indexOf(a), ib = g.order.indexOf(b);
        return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
      });
      const wrap = document.createElement('div');
      const gLabel = T['group_' + g.key] || g.label;
      wrap.className = 'vvl-group'; wrap.setAttribute('role', 'group'); wrap.setAttribute('aria-label', gLabel);
      wrap.innerHTML = '<span aria-hidden="true">' + gLabel + '</span>';
      const mk = (val, text, n) => {
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'vvl-chip'; b.dataset.group = g.key; b.dataset.value = val;
        b.innerHTML = text + (n != null ? ' <small>' + n + '</small>' : '');
        b.addEventListener('click', () => { state[g.key] = state[g.key] === val ? '' : val; apply(); });
        return b;
      };
      keys.forEach(k => wrap.appendChild(mk(k, vals.get(k).label, vals.get(k).n)));
      groupsEl.appendChild(wrap);
      live.push(g.key);
    });

    /* product menu */
    productEl.querySelectorAll('option:not([value=""])').forEach(o => o.remove());
    [...products.entries()].sort((a, b) => a[1].title.localeCompare(b[1].title)).forEach(([h, p]) => {
      const o = document.createElement('option');
      o.value = h; o.textContent = p.title + ' (' + p.n + ')';
      productEl.appendChild(o);
    });
    if (products.size < 2) productEl.closest('.vvl-field').hidden = true;

    /* read the address bar */
    const params = new URLSearchParams(location.search);
    state.q = (params.get('q') || '').trim();
    if (['product', 'ugc'].includes(params.get('type'))) state.type = params.get('type');
    if (products.has(params.get('product'))) state.product = params.get('product');
    live.forEach(k => { const v = params.get(k); if (v && items.some(li => li.dataset[k] === v)) state[k] = v; });
    qEl.value = state.q; productEl.value = state.product;

    function writeUrl() {
      const p = new URLSearchParams();
      if (state.type) p.set('type', state.type);
      if (state.q) p.set('q', state.q);
      if (state.product) p.set('product', state.product);
      live.forEach(k => { if (state[k]) p.set(k, state[k]); });
      const qs = p.toString();
      try { history.replaceState(null, '', location.pathname + (qs ? '?' + qs : '') + location.hash); } catch (e) { /* ignore */ }
    }

    function apply() {
      const tokens = state.q.toLowerCase().split(/\s+/).filter(Boolean);
      let shown = 0;
      items.forEach(li => {
        let ok = true;
        if (state.type && li.dataset.type !== state.type) ok = false;
        if (state.product && !(li.dataset.products || '').split(/\s+/).includes(state.product)) ok = false;
        live.forEach(k => { if (state[k] && li.dataset[k] !== state[k]) ok = false; });
        if (ok && tokens.length) { const hay = li.dataset.search || ''; ok = tokens.every(t => hay.includes(t)); }
        li.hidden = !ok;
        if (ok) shown++;
      });
      /* a following section with nothing to show is hidden; the first section keeps its filters and the empty note */
      followers.forEach(f => { f.hidden = !f.querySelector('.vvl-item:not([hidden])'); });
      root.querySelectorAll('.vvl-segbtn').forEach(b => b.setAttribute('aria-pressed', String(state.type === b.dataset.type)));
      root.querySelectorAll('.vvl-chip').forEach(b => b.setAttribute('aria-pressed', String(state[b.dataset.group] === b.dataset.value)));
      const active = !!(state.type || state.q || state.product || live.some(k => state[k]));
      clearEl.hidden = !active;
      const one = items.length === 1;
      countEl.textContent = active
        ? (one ? T.match_one : T.match_other).replace('{shown}', shown).replace('{total}', items.length)
        : (one ? T.count_one : T.count_other).replace('{n}', items.length);
      emptyEl.hidden = shown > 0;
      writeUrl();
    }

    /* listeners on elements that survive a theme-editor re-render are dropped before the section is set up again */
    if (root._vvlAbort) root._vvlAbort.abort();
    const ac = new AbortController(); root._vvlAbort = ac;
    const on = { signal: ac.signal };
    let t = 0;
    qEl.addEventListener('input', () => { clearTimeout(t); t = setTimeout(() => { state.q = qEl.value.trim(); apply(); }, 120); }, on);
    qEl.addEventListener('search', () => { state.q = qEl.value.trim(); apply(); }, on);
    productEl.addEventListener('change', () => { state.product = productEl.value; apply(); }, on);
    clearEl.addEventListener('click', () => { Object.keys(state).forEach(k => { state[k] = ''; }); qEl.value = ''; productEl.value = ''; apply(); qEl.focus(); }, on);

    tools.hidden = false;
    apply();
  }

  /* group the sections: a following section joins the nearest section above it that has its own filters */
  function run() {
    const roots = [...document.querySelectorAll('[data-vvl]')];
    const groups = [];
    roots.forEach(r => {
      if (r.hasAttribute('data-vvl-follow') && groups.length) groups[groups.length - 1].followers.push(r);
      else groups.push({ root: r, followers: [] });
    });
    groups.forEach(g => init(g.root, g.followers));
  }
  run();
  /* theme editor: a re-rendered section is new markup, so set the page up again */
  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('[data-vvl]').forEach(r => { delete r.dataset.vvlReady; r.hidden = false; });
    run();
  });
})();
